export const REQUEST_MASTER_ANALYTICS = "REQUEST_MASTER_ANALYTICS";
export const SET_MASTER_ANALYTICS = "SET_MASTER_ANALYTICS";
export const ERROR_GET_MASTER_ANALYTICS = "ERROR_GET_MASTER_ANALYTICS";